var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.jz=require("ttag");module.exports=$CLJS.jz;